$(document).ready(function () {

    $(".productBoxWrapper").click(function () {
        window.location = $(this).find("a").attr("href");
        return false;
    });

    if ($(window).width() > 1118) {
        $(".acc-Icon").css("visibility", "hidden");
    }

    let isHandlingKeyboardEvent = false; // Flag to prevent multiple keyboard events triggering
    if ($("#HideAccordion").val() === "True" && $(window).width() >= 768) {

        $(".ProductFamily--Row .accordion-content").css("display", "block");
        $(".up").css("display", "none");
        $(".down").css("display", "none");
        $("section.acc-data .pdt-title").addClass("no_arrow");
        $(".pdt-img").css("display", "none");
        $(".pdt-desc").css("margin", "16px 0px");
        $(".title-section").css("margin-left", "0px");
        $(".ProductFamily--Row .accordion-title").css("padding", "0px");
        $(".ProductFamily--Row .accordion-title").attr("aria-expanded", 'true');
    } else {

        $(".pdt-img").css("display", "flex");
        $("section.acc-data .pdt-title").removeClass("no_arrow");
        $('.ProductFamily--Row .accordion-title').on('click keypress', function (event) {
            if (isHandlingKeyboardEvent) return;
            if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
                isHandlingKeyboardEvent = true;
                $(this).find("span.pdt-title>img").attr('src', ''); // Clear the src
                $(this).find("span.pdt-title>img").removeAttr('src');

                if ($(this).next().css('display') === 'none') {

                    $(this).find(".up").css("display", "block");
                    $(this).find(".down").css("display", "none");


                } else {

                    $(this).find(".up").css("display", "none");
                    $(this).find(".down").css("display", "block");
                }
                var expanded = $(this).attr("aria-expanded") === 'true';
                $(this).attr("aria-expanded", !expanded);
                $(this).next().slideToggle(300);

                $(this).toggleClass('open', 300);
                setTimeout(function () {
                    isHandlingKeyboardEvent = false;
                }, 300);
            }
        });

    }


    $.fn.jQueryEqualHeight = function (innerDiv) {
        if (innerDiv === undefined) {
            innerDiv = '.productBoxWrapper';
        }
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            topPosition = 0;
        $(this).each(function () {
            if (!$(this).hasClass("hidden")) {
                $(this).find(innerDiv).height('auto')
                topPosition = $(this).position().top;
                if (currentRowStart !== topPosition) {
                    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                        rowDivs[currentDiv].find(innerDiv).height(currentTallest);
                    }
                    rowDivs.length = 0;
                    currentRowStart = topPosition;
                    currentTallest = $(this).find(innerDiv).height();
                    rowDivs.push($(this));
                } else {
                    rowDivs.push($(this));
                    currentTallest = (currentTallest < $(this).find(innerDiv).height()) ? ($(this).find(innerDiv).height()) : (currentTallest);
                }
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].find(innerDiv).height(currentTallest);
                }
            }
        });
    };
    $(window).on('load', function () {
        setTimeout(function () {
            equal_height();
        }, 200);

    });
    $(window).resize(function () {
        $(".accordion-title").toggleClass('close', 300);
        if ($(window).width() > 1118) {
            $(".acc-Icon").css("visibility", "hidden");

        } else {

            if ($('.ProductFamily--Row .accordion-title').next().css('display') === 'none') {
                $(this).find(".up").css("display", "block");
                $(this).find(".down").css("display", "none");
                $(".acc-Icon").css("visibility", "visible");
            } else {

                $(this).find(".up").css("display", "none");
                $(this).find(".down").css("display", "block");
                $(".acc-Icon").css("visibility", "visible");
            }

        }

        setTimeout(function () {
            equal_height();
        }, 200);
    });

    function equal_height() {
        // Equal Card Height, Text Height and Title Height
        $('.productBoxWrapper').jQueryEqualHeight('.productBoxMain .productBoxText .title');
        $('.productBoxWrapper').jQueryEqualHeight('.productBoxMain .productBoxText .paraDiv');

        if ($('.searchResultSection').length) {
            $('.productBoxWrapper').jQueryEqualHeight('.detailAbsorbency');
            $('.productBoxWrapper').jQueryEqualHeight('.detailColor');
            $('.productBoxWrapper').jQueryEqualHeight('.productBoxFooter');
        }

        if ($('.js-review').length) {
            setTimeout(function () {
                $('.productBoxWrapper').jQueryEqualHeight('.productBoxMain .productBoxText .js-review');
                if ($('.productBoxMain .productBoxText .js-review').height() > 0) {
                    $('.productBoxMain .productBoxText .js-review').css('opacity', '1');
                }
            }, 200);
        }
        if ($('.js-review').length && $('.pr-no-reviews').css('display') === 'none') {
            setTimeout(function () {
                $('.productBoxWrapper').jQueryEqualHeight('.productBoxMain .productBoxText .js-review');
                if ($('.productBoxMain .productBoxText .js-review').height() > 0) {
                    $('.productBoxMain .productBoxText .js-review').css('opacity', '1');
                }
            }, 200);
        }
    }

    $(document).on('click', function (e) {
        setTimeout(function () {
            equal_height(e);
        }, 50)
    });
    $('.Tags__Button, .clear-tags, .js-product-filter-btn, .js-product-filter-applied-list').on('click keypress', function (e) {
        setTimeout(function () {
            equal_height(e);
        }, 800)
    })
});

//GA4 product card click
$(".productBoxWrapper").off("click").on("click", function (event) {
    event.preventDefault();
    var productNameElement = $(this).find(".productBoxText .title");
    var productGpimIDElement = $(this).find(".productBoxText .product-gpimid");
    var productUrlElement = $(this).find(".productBoxText .product-url");

    var productName = productNameElement.length > 0 ? productNameElement.text().replace(/\n/g, '').trim() : '';
    var productGpimID = productGpimIDElement.length > 0 ? productGpimIDElement.val() : '';
    var productUrl = productUrlElement.length > 0 ? productUrlElement.val() : '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "ga4_product_click",
        "ga4_data": {
            "single_item_id": productGpimID,
            "single_item_name": productName,
            "link_text": productName,
            "link_url": productUrl
        }
    });
    
    window.location = $(this).find("a").attr("href");
    return false;
});
